import { useState } from "react";

export type CarouselImage = {
  src: string;
  alt: string;
};

export function Carousel({
  className,
  images,
  children,
}: {
  className?: string;
  images: CarouselImage[];
  children: React.ReactNode;
}) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div
      className={`relative flex justify-center items-center ${className}`}
      role="button"
      tabIndex={0}
      onClick={() => {
        setSelectedIndex((index) => (index === images.length ? 0 : index + 1));
      }}
    >
      {images.map((image, index) => (
        <img
          key={image.src}
          alt={image.alt}
          className={`max-h-full absolute transition-opacity duration-1000 ${selectedIndex === index ? "opacity-100" : "opacity-0 pointer-events-none"}`}
          decoding="async"
          loading="lazy"
          src={image.src}
        />
      ))}
      <div
        className={`w-full md:w-[50%] lg:w-[25%] flex flex-row gap-4 absolute transition-opacity duration-1000 ${selectedIndex === images.length ? "opacity-100" : "opacity-0 pointer-events-none"}`}
      >
        {children}
      </div>
    </div>
  );
}
